import { createFocusTrap } from 'focus-trap';

/**
 * Handle everything related to "headerOffcanvas"
 * This is used for the desktop and also for the mobile version of the menu
 */
export const offCanvas = (): void => {
  const offCanvasOverlay = document.querySelector<HTMLElement>('.js-offcanvas');
  const offCanvasMenu =
    document.querySelector<HTMLElement>('.js-offcanvas-menu');
  const offCanvasToggles = document.querySelectorAll<HTMLElement>(
    '.js-offcanvas-toggle',
  );

  const ploneToolbar = document.querySelector<HTMLElement>('#edit-bar');

  if (!offCanvasOverlay || !offCanvasMenu || !offCanvasToggles.length) {
    console.error('OffCanvas elements not found');
    return;
  }

  /**
   * Closes the OffCanvas
   */
  const closeOffcanvas = (): void => {
    const handleAnimationEnd = () => {
      if (offCanvasOverlay) {
        offCanvasOverlay.style.display = 'none';
      }
      offCanvasMenu?.removeEventListener('animationend', handleAnimationEnd);

      if (ploneToolbar) ploneToolbar.style.display = 'block';
    };

    offCanvasMenu?.addEventListener('animationend', handleAnimationEnd);

    if (offCanvasOverlay) {
      offCanvasOverlay.setAttribute('aria-hidden', 'true');
      offCanvasOverlay.classList.remove('is-open');
      document.body.classList.remove('offcanvas-is-open');
      // eslint-disable-next-line no-use-before-define
      focusTrap.deactivate();
    }

    offCanvasToggles.forEach(toggle => {
      toggle.classList.remove('is-open');
    });

    // eslint-disable-next-line no-use-before-define
    window.removeEventListener('click', handleClickOutside);
  };

  const focusTrap = createFocusTrap(offCanvasMenu, {
    // clickOutsideDeactivates: true,
    allowOutsideClick: true,
    escapeDeactivates: true,
    fallbackFocus: offCanvasMenu,
    onDeactivate: closeOffcanvas,
  });

  /**
   * handleClickOutside()
   * @param {Event} event
   */
  const handleClickOutside = (event: MouseEvent): void => {
    const { target } = event;
    if (offCanvasMenu) {
      const isClickOutside = !offCanvasMenu.contains(target as Node);

      if (isClickOutside) {
        closeOffcanvas();
      }
    }
  };

  /**
   * Opens the OffCanvas
   */
  const openOffcanvas = (): void => {
    if (offCanvasOverlay) {
      offCanvasOverlay.style.display = 'block';
      offCanvasOverlay.setAttribute('aria-hidden', 'false');
      offCanvasOverlay.classList.add('is-open');
      document.body.classList.add('offcanvas-is-open');
      focusTrap.activate();

      if (ploneToolbar) ploneToolbar.style.display = 'none';

      window.addEventListener('click', handleClickOutside);
    }
  };

  const toggleOffcanvas = (event: MouseEvent): void => {
    event.stopPropagation();
    const toggle = event.target as HTMLElement;

    if (offCanvasOverlay?.classList.contains('is-open')) {
      closeOffcanvas();
      if (ploneToolbar) ploneToolbar.classList.add('animate');
    } else {
      toggle.classList.add('is-open');
      openOffcanvas();
      if (ploneToolbar) ploneToolbar.classList.remove('animate');
    }
  };

  // Initialize event listeners
  offCanvasToggles.forEach(toggle => {
    toggle.addEventListener('click', toggleOffcanvas);
  });
};
